<div #swiperEl tabindex="0" class="swiper mx-auto max-w-[582px]">
  <div #prevEl class="swiper-button-prev"></div>
  <div #nextEl class="swiper-button-next"></div>
  <div class="swiper-wrapper">
    @for (item of carouselItems; track item) {
      <div class="swiper-slide">
        <div class="slide-container px-6 max-w-[639px] min-[639px]:max-w-none min-[639px]:w-full">
          <img [src]="item.url" [alt]="item.alt ?? 'Image from Aceable'" [width]="534" [height]="534">
        </div>
      </div>
    }
  </div>
</div>
